<template>
  <div>
    <v-dialog v-model="shower" scrollable width="900px" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="pa-3">
          <div v-if="announce">{{ $t("NewUpdate.announ3") }}</div>
          <div v-else>{{ $t("onechat.consentlist") }}</div>
          <v-spacer></v-spacer>

          <v-btn outlined color="error" @click="Fn_Close()">
            {{ $t("consentform.close") }}</v-btn
          >
        </v-card-title>
        <v-card-text>
          <v-layout row wrap justify-center mt-2 mb-5>
            <v-flex xs11 sm11 md3 lg3>
              <v-text-field
                hide-details
                dense
                outlined
                :label="$t('NewUpdate.employeecode')"
                color="#077893"
                v-model="NumId"
              ></v-text-field>
            </v-flex>
            <v-flex xs11 sm11 md2 lg2 pl-3>
              <v-btn
                dark
                color="#077893"
                @click="Fn_GetEmployeeId"
                :loading="loadingSearch"
                >{{ $t("consentlist.search") }}</v-btn
              >
            </v-flex>
            <v-flex
              xs11
              sm11
              md6
              lg6
              justify-end
              text-right
              v-if="filteredData.length > 0"
            >
              <v-card outlined>
                <v-card-title primary-title class="pa-2">
                  <b
                    >{{ $t("NewUpdate.Allname") }}
                    <v-chip class="ma-1 white--text" color="#077893">
                      {{ filteredData.length }}
                    </v-chip>
                    {{ $t("consentlist.list") }}</b
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    dark
                    rounded
                    color="#077893"
                    :disabled="filteredData.length == 0"
                    @click="Fn_Save(filteredData)"
                    >{{ $t("email.text7") }}</v-btn
                  >
                </v-card-title>
                <v-card-text
                  class="text-left"
                  style="max-height: 160px; overflow: auto"
                >
                  <v-layout
                    row
                    wrap
                    mt-2
                    mb-2
                    justify-center
                    align-center
                    v-for="(item, i) in filteredData"
                    :key="i"
                    class="d-flex align-center hover"
                  >
                    <v-flex xs11 sm11 md10 lg10 text-left>
                      {{ i + 1 }}. {{ item.TitleNameTh }}{{ item.NameTh }}
                      <br />
                      <b>{{ $t("Profile.accountId") }}</b>
                      {{ item.AccountId }}
                    </v-flex>
                    <v-flex xs11 sm11 md1 lg1>
                      <v-btn
                        class="mx-2"
                        icon
                        dark
                        color="error"
                        @click="deleteItem(i)"
                      >
                        <v-icon>mdi-trash-can</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              xs11
              sm11
              md6
              lg6
              v-else-if="filteredData.length == 0"
            ></v-flex>
          </v-layout>
          <!-- <v-layout
            row
            wrap
            justify-center
            align-center
            mt-3
            v-if="filteredData.length > 0"
          >
            <v-flex xs11 sm11 md11 lg11>
              <v-card-text>
                <v-data-table
                  :headers="headers"
                  v-model="SelectNameAccount"
                  :items="filteredData"
                  item-key="AccountId"
                  show-select
                  hide-default-footer
                  :loading="btnSendLoading"
                  :page.sync="Page"
                  @page-count="PageCount = $event"
                  loading-text="กำลังดาวน์โหลดข้อมูล..."
                  :items-per-page="ItemPerPage"
                >
                  <template v-slot:[`item.No`]="{ item }">
                    <div v-for=" i in item" :key="i">
                      {{ i + 1 }}
                    </div>
                  </template>
                  <template v-slot:[`item.NameTh`]="{ item }">
                    {{ item.TitleNameTh }} {{ item.NameTh }}
                  </template>
                  <template v-slot:[`item.NameEng`]="{ item }">
                    {{ item.TitleNameEng }} {{ item.NameEng }}
                  </template>
                </v-data-table>
                <v-pagination
                  :total-visible="7"
                  class="pt-2 pb-2"
                  circle
                  color="#077893"
                  v-model="Page"
                  :length="PageCount"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                >
                </v-pagination>
                <v-flex xs6 lg6>
                  <v-btn class="mx-2" fab dark small color="error">
                    <v-icon dark> mdi-minus </v-icon>
                  </v-btn>
                </v-flex>
              </v-card-text>
            </v-flex>
          </v-layout> -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <DialogCheckUser
      :show="DialogList"
      :_detail="ItemsCheckUser"
      :_payload="payloadUserOnechat"
      @closeDialogDelete="DialogList = false"
    />
  </div>
</template>
<script>
import DialogCheckUser from "@/components/dialog/Announce/Onechat/DialogAnnounceCheckUserOnechat.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogCheckUser },
  props: ["show", "announce"],
  data: function () {
    return {
      NumId: "",
      ItemsEmployeeId: "",
      AddItem: [],
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      filteredData: [],
      SelectNameAccount: [],
      ItemsCheckUser: [],
      DialogList: false,
      loadingSearch: false,
      btnSendLoading: false,
      payloadUserOnechat: {},
    };
  },
  created() {},
  computed: {
    ...mapGetters(["DataAnnounce"]),
    ...mapGetters(["DataGroupConsent"]),
    ...mapGetters(["DataGroupOneChatSearch"]),
    shower: {
      get() {
        return this.show;
      },
    },
    _profile: {
      get() {
        return this.$store.getters.profile;
      },
    },
    _apiKey: {
      get() {
        return this.$store.getters.apikey;
      },
    },
    _accesskey: {
      get() {
        return this.$store.getters.accessKey;
      },
    },
    _DataGroupOneChatSearch: {
      get() {
        return this.DataGroupOneChatSearch || "-";
      },
    },
    _DataAnnounce: {
      get() {
        return this.DataAnnounce || "-";
      },
    },
    headers: {
      get() {
        return [
          {
            text: this.$i18n.t("dashboard.num"),
            value: "No",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.nameTh"),
            value: "NameTh",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.nameEng"),
            value: "NameEng",
            sortable: false,
          },
        ];
      },
    },
  },
  watch: {
    show(val) {
      if (val === true) {
        this.NumId = "";
        this.NumId = "";
        this.filteredData = [];
        this.ItemsEmployeeId = "";
        this.AddItem = [];
      }
    },
  },
  mounted() {},
  methods: {
    deleteItem(index) {
      this.filteredData.splice(index, 1);
      this.AddItem.splice(index, 1);
    },
    Fn_Save(val) {
      // this.$emit("closeDialog");
      // this.$emit("confirmEmployee", val);
      if (this._DataGroupOneChatSearch.Consent === undefined) {
        this.$emit("closeDialog");
        this.$emit("confirmEmployee", val);
      } else if (this._DataGroupOneChatSearch.Consent.length > 0) {
        this.Fn_CheckUserOnechat();
      }
    },
    async Fn_CheckUserOnechat() {
      for (var i in this.filteredData) {
        delete this.filteredData[i].Email;
        delete this.filteredData[i].Mobile;
      }
      this.payloadUserOnechat = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        Receiver: this.filteredData,
        AnnounceName: this._DataAnnounce,
        PolicyId: this._DataGroupOneChatSearch.Policy[0].PolicyId,
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "onechat/CheckUserAnnounce",
          this.payloadUserOnechat
        )
        .then((response) => {
          this.LoadingSentConsent = false;
          if (response.data.Status === "OK") {
            this.ItemsCheckUser = response.data.Message;
            this.DialogList = true;
            this.$emit("closeDialog");
            this.$store.dispatch("SET_DATA_CHECK_USER", this.ItemsCheckUser);
          } else {
            this.LoadingSentConsent = false;
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingSentConsent = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetEmployeeId() {
      this.loadingSearch = true;
      this.btnSendLoading = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        EmployeeId: this.NumId,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/GetEmployee",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingSearch = false;
          this.btnSendLoading = false;
          this.NumId = "";
          if (response.data.Status === "OK") {
            this.ItemsEmployeeId = response.data.Message;

            this.AddItem.push(this.ItemsEmployeeId);
            this.filteredData = this.AddItem.filter(function (
              item,
              index,
              self
            ) {
              return (
                index ===
                self.findIndex(function (t) {
                  return t.NameTh === item.NameTh;
                })
              );
            });
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.NumId = "";
          this.loadingSearch = false;
          this.btnSendLoading = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Close() {
      this.$emit("closeDialog");
      this.NumId = "";
      this.filteredData = [];
      this.ItemsEmployeeId = "";
      this.AddItem = [];
    },
  },
};
</script>
<style scoped>
.noteStlye {
  width: 150px;
  word-wrap: break-word;
}

.hover:hover {
  background-color: #ddf7ff;
}
</style>
